var WDN = WDN || {};

if (typeof WDN.CartItem === "undefined") {
  WDN.CartItem = (function () {
    //  Base
    class WDNCartBase extends HTMLElement {
      constructor() {
        super();
        this.desktopContainer = document.querySelector("[data-cart-layout]");
        this.drawerContainer = document.querySelector(
          "[data-cartdrawer-layout]"
        );
      }

      outputLayout(newLayout, target) {
        if (newLayout && target) {
          target.innerHTML = newLayout;
        }
      }

      setLoading() {
        document.body.setAttribute("data-loading", "");
      }

      clearLoading() {
        document.body.removeAttribute("data-loading");
      }

      customEvent(data) {
        var newEvent = new CustomEvent(data.name, {
          detail: data.detail,
        });
        if (data.target) {
          var target = document.querySelector(data.target);
        }
        if (!target) {
          var target = document.body;
        }
        target.dispatchEvent(newEvent);
      }

      renderSections(sections) {
        if (this.desktopContainer || this.drawerContainer) {
          if (sections.hasOwnProperty("cart-layout")) {
            this.outputLayout(sections["cart-layout"], this.desktopContainer);
          }

          if (sections.hasOwnProperty("cart-layout-drawer")) {
            this.outputLayout(
              sections["cart-layout-drawer"],
              this.drawerContainer
            );
          }
        }
      }
    }

    //  Quantity
    class WDNQuantity extends WDNCartBase {
      constructor() {
        super();
        /* Nodes */
        this.input = this.querySelector("[data-quantity-input]");
        this.increaseBtn = this.querySelector(
          "[data-quantity-control='increase']"
        );
        this.decreaseBtn = this.querySelector(
          "[data-quantity-control='decrease']"
        );
        /* Attributes  */
        this.id = this.getAttribute("id");
        this.min = this.input.getAttribute("min") || -999;
        this.min = parseInt(this.min); // parseInt on a new line because 0 == false and "0" == true
        this.max = parseInt(this.input.getAttribute("max")) || 999;
        this.value = parseInt(this.input.value);

        /* Init  */
        this.init();
      }

      // sets value of the input
      set(newValue) {
        this.value = newValue;
        this.input.value = newValue;
        this.customEvent({
          name: "quantity:change",
          detail: this,
        });
        if (typeof this.onQuantityChange === "function") {
          this.onQuantityChange(); // allows us to extend component and provide callback
        }
      }

      // returns input value
      get() {
        return this.value;
      }

      // increases input value by 1
      increase() {
        var newValue = this.value + 1;
        if (newValue <= this.max) {
          this.set(newValue);
        }
      }
      // decreases input value by 1
      decrease() {
        var newValue = this.value - 1;
        if (newValue >= this.min) {
          this.set(newValue);
        }
      }

      inputIsValid() {
        var inputValue = this.input.value;
        return inputValue >= this.min && inputValue <= this.max;
      }

      // validates and updates input value
      inputOnChange() {
        // Validating if input value is in between min and max
        if (this.inputIsValid()) {
          this.set(this.input.value);
        }
      }

      bind() {
        if (this.increaseBtn) {
          this.increaseBtn.addEventListener("click", this.increase.bind(this));
        }
        if (this.decreaseBtn) {
          this.decreaseBtn.addEventListener("click", this.decrease.bind(this));
        }

        this.input.addEventListener("change", this.inputOnChange.bind(this));
      }

      // disables increase button
      disableIncButton() {
        this.disableButton(this.increaseBtn);
      }
      // disables decrease button
      disableDecButton() {
        this.disableButton(this.decreaseBtn);
      }

      // enables increase button
      enableIncButton() {
        this.enableButton(this.increaseBtn);
      }

      // enables decrease button
      enableDecButton() {
        this.enableButton(this.decreaseBtn);
      }

      disableButton(button) {
        if (button) {
          button.disabled = true;
        }
      }
      enableButton(button) {
        if (button) {
          button.disabled = false;
        }
      }

      enableControls() {
        this.enableDecButton();
        this.enableIncButton();
      }

      setInitialState() {
        //  enabling all controls
        this.enableControls();
        // checking if next values will go past min/max
        var incValue = this.value + 1;
        var decValue = this.value - 1;
        // disabling inccrease button
        if (incValue > this.max) {
          this.disableIncButton();
        }
        // disabling decrease button
        if (decValue < this.min) {
          this.disableDecButton();
        }
      }

      init() {
        // disabling buttons if next value will hit min/max
        this.setInitialState();
        this.bind();
      }
    }

    // Cart Quantity
    class WDNCartQuantity extends WDNQuantity {
      constructor() {
        super();
      }

      onSuccess(res) {
        /*
        this.renderSections(res.sections);*/
        this.customEvent({
          name: "cart:updated",
          detail: res,
        });

        if (this.value === 0) {
          this.customEvent({
            name: "cart_item:removed",
            detail: res,
          });
        }

        if (WDN.CartDrawer) {
          WDN.CartDrawer.refresh();
        } else {
          WDN.CartPage.refresh();
        }

        this.clearLoading();
      }

      onError() {
        this.clearLoading();

        this.customEvent({
          name: "cart:error",
          detail: res,
        });
      }

      onQuantityChange() {
        var id = this.id; // product id
        var value = this.value; // input value
        this.setLoading();
        WDN.Request.Post({
          url: Shopify.routes.root + "cart/update.js",
          data: { updates: { [id]: value } },
          onSuccess: this.onSuccess.bind(this),
          onError: this.onError.bind(this),
          type: "JSON",
        });
      }
    }

    // Cart Remove
    class WDNCartRemove extends WDNCartBase {
      constructor() {
        super();
        this.id = this.getAttribute("data-id");
        this.init();
      }

      onSuccess(res) {
        this.customEvent({
          name: "cart:updated",
          detail: res,
        });

        this.customEvent({
          name: "cart_item:removed",
          detail: res,
        });

        if (WDN.CartDrawer) {
          WDN.CartDrawer.refresh();
        } else {
          WDN.CartPage.refresh();
        }

        this.clearLoading();
      }

      onError(res) {
        this.clearLoading();
        this.customEvent({
          name: "cartitem:error",
          detail: res,
        });
      }

      onClick() {
        this.setLoading();
        WDN.Request.Post({
          url: Shopify.routes.root + "cart/update.js",
          data: { updates: { [this.id]: 0 } },
          onSuccess: this.onSuccess.bind(this),
          onError: this.onError.bind(this),
          type: "JSON",
        });
      }

      bind() {
        this.addEventListener("click", this.onClick.bind(this));
      }

      init() {
        this.bind();
      }
    }

    customElements.define("wdn-quantity", WDNQuantity);
    customElements.define("wdn-cart-quantity", WDNCartQuantity);
    customElements.define("wdn-cart-remove", WDNCartRemove);

    return {};
  })();
}
